import { useState } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import AuthInfoObj from "../../ApiServices/AuthInfoObj";
import { APPID, DOMAIN_NAME, VERSION, REFERER } from "../../Config.js";

const LedgerService = () => {
  const [balanceData, setBalanceData] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [ledgerReportData, setLedgerReportData] = useState([]);
  const [searchInputs, setSearchInputs] = useState({
    accountNo: "",
    transactionID: "",
  });
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const getToday = () => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  };

  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());

  const formatDateForAPI = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const toggleSearch = () => {
    setShowSearch((prev) => !prev);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  const getLedgerReport = async () => {
    try {
      setLoading(true);
      const bodyObject = {
        isExport: false,
        topRows: 100,
        oid: 0,
        tid: 0,
        WalletTypeID: 1,
        status: 0,
        accountNo: searchInputs?.accountNo,
        transactionID: searchInputs?.transactionID,
        fromDate: formatDateForAPI(fromDate),
        toDate: formatDateForAPI(toDate),
      };
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/LedgerReport",
        data: bodyObject,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.statuscode === 1) {
        setLedgerReportData(res?.ledgerReport);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getLedgerReport :", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    getBalanceUser,
    balanceData,
    toggleSearch,
    showSearch,
    toDate,
    setToDate,
    fromDate,
    setFromDate,
    getLedgerReport,
    handleInputChange,
    searchInputs,
    ledgerReportData,
    loading,
    itemsPerPage,
    currentPage,
    setCurrentPage,
  };
};

export default LedgerService;
